<template>
  <div class="video-wrapper">
    <iframe
      v-if="!!url"
      :src="url"
      allowtransparency="true"
      frameborder="no"
      allow="autoplay"
      class="audio-player"
    />
  </div>
</template>

<script>
import { eventBus } from '@/lib/events';

export default {
  name: 'ActionEntertainAudioPlayer',
  props: {
    url: String,
  },
  data() {
    return {
      playerWidget: null,
      savedVolume: 0,
    };
  },
  computed: {
    isSoundCloud() {
      return (this.url || '').includes('soundcloud');
    },
  },
  watch: {
    url() {
      this.addSoundCloudWidgetAPI();
    },
  },
  methods: {
    async addSoundCloudWidgetAPI() {
      await this.$nextTick();

      if (!this.isSoundCloud) {
        this.playerWidget = null;
        return;
      }

      if (window?.SC) {
        this.assignPlayerWidget();
      }

      const script = document.createElement('script');
      script.id = 'soundcloud';
      script.src = 'https://w.soundcloud.com/player/api.js';
      script.onload = () => {
        this.assignPlayerWidget();
      };
      document.querySelector('head').append(script);
    },

    assignPlayerWidget() {
      const audioPlayerElement = this.$el.querySelector('.audio-player');
      this.playerWidget = SC.Widget(audioPlayerElement);
    },

    runPlayerMethod(method = '', param = '') {
      if (!method || !this.playerWidget || !this.playerWidget[method]) {
        return null;
      }

      return this.playerWidget[method](param);
    },

    toggleMusicVolume(dropMusicVolume = false) {
      if (!this.playerWidget) return;

      // drop music volume 5/100
      if (dropMusicVolume) {
        this.playerWidget.getVolume((val) => {
          this.savedVolume = val;
        });
        this.runPlayerMethod('setVolume', '2');
        return;
      }

      // restore music volume
      if (this.savedVolume) {
        this.runPlayerMethod('setVolume', this.savedVolume);
      }
    },
  },
  created() {
    this.addSoundCloudWidgetAPI();
    eventBus.on('dropMusicVolume', this.toggleMusicVolume);
  },
  beforeDestroy() {
    eventBus.off('dropMusicVolume', this.toggleMusicVolume);
  },
};
</script>
